import ReactGA from 'react-ga4';

import { IS_DEVELOPMENT_MODE } from 'constants/ui';

export const initializationGoogle = () => {
  const GA_KEY = IS_DEVELOPMENT_MODE ? '' : 'GTM-PFJRMJ28';

  if (!GA_KEY) {
    return;
  }

  ReactGA.initialize([
    {
      trackingId: GA_KEY,
    },
    // {
    //   trackingId: "your second GA measurement id",
    // },
  ]);
};
